import React from 'react'
import { Image, Modal, Spinner } from 'react-bootstrap'
import Lottie from 'react-lottie-player'
import lottieJson from '../resources/coin-confitti.json'
import { AgeButton, MainContainer } from '../theme'

function DialogBox(props) {
  const {
    title,
    visible,
    message,
    buttonText,
    routeTo,
    imgSrc,
    borderColor,
    closeDailogBox,
    color,
    loading,
    lottieJsonState,
    type,
    disabledClicked,
  } = props

  return (
    <Modal
      style={{ textAlign: 'center', border: '1px solid black' }}
      show={visible}
      className="dialog-box"
    >
      <MainContainer
        padding={'32px 16px'}
        style={{ border: `2px solid ${borderColor}`, borderRadius: '30px' }}
      >
        {lottieJsonState && (
          <Lottie
            loop={false}
            play
            animationData={lottieJsonState ? lottieJson : {}}
            style={{ width: 150, height: 120, display: 'inline-block' }}
          />
        )}

        <Image src={imgSrc} style={{ height: '70px' }} />
        <Modal.Header style={{ justifyContent: 'center', paddingTop: '0px' }}>
          <Modal.Title className="font">
            <strong>{title}</strong>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="m-0 mt-1 font"> {message}</p>
        </Modal.Body>
        <div className="mt-1">
          {type && (
            <AgeButton
              style={{ marginRight: '10px' }}
              className="font"
              onClick={() => closeDailogBox(false)}
              padding={'7px 25px'}
              border={color}
              color={color}
              bgcolor={'white'}
              disabled={loading}
              marginRight={'5px'}
            >
              {disabledClicked ? 'वापस जायें' : 'नहीं'}
            </AgeButton>
          )}
          <AgeButton
            className="font"
            onClick={() => closeDailogBox(true)}
            padding={'7px 25px'}
            border={color}
            color={color}
            bgcolor={'white'}
            disabled={loading}
          >
            {loading ? (
              <Spinner
                className="mr-2"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              buttonText
            )}
          </AgeButton>
        </div>
      </MainContainer>
    </Modal>
  )
}

export default DialogBox
